import type { ReactNode } from 'react';
import { Avatar } from '@mantine/core';
import { getMantineAvatarColor, getMemberInitials } from '@/constants/roles';
import { getMemberLabel } from '@/utils/getMemberLabel';
import type { WorkspaceMember } from '@/types/workspace';
import styles from './MemberOptionRow.module.css';

interface MemberOptionRowProps {
  readonly member: WorkspaceMember;
}

export function MemberOptionRow({ member }: MemberOptionRowProps): ReactNode {
  const displayName = getMemberLabel(member);

  return (
    <div className={styles.optionRow}>
      <Avatar
        src={member.avatarUrl}
        alt={displayName}
        color={getMantineAvatarColor(member.userId)}
        radius="xl"
        size="sm"
      >
        {getMemberInitials(member.displayName, member.email)}
      </Avatar>
      <div className={styles.optionInfo}>
        <span className={styles.optionName}>{displayName}</span>
        {member.displayName && (
          <span className={styles.optionEmail}>{member.email}</span>
        )}
      </div>
    </div>
  );
}
